export default "//file.bilionpass.com/japandx-web/0.0.1/static/people-icon.173148eb-f23cc9.svg";